module.exports = __webpack_public_path__ + "img/app-gallery.1ffa3fc4.svg";